import { render, staticRenderFns } from "./CartSelector.vue?vue&type=template&id=b2f64bb6"
import script from "./CartSelector.vue?vue&type=script&lang=js"
export * from "./CartSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports